import {useEffect, useState} from 'react';

import {TextField} from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import {REGULAR_EXPRESSIONS, REGULAR_EXPRESSIONS_ERROR_TEXTS} from '../../../../const';
import useReport from '../../../../hooks/providers/useReport';
import useReportViews from '../../../../hooks/providers/useReportViews';
import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';

const SaveReportViewModal = () => {
  const {selectedReport} = useReport();
  const {reportViews, isSaveReportViewModalOpen: isOpen, setIsSaveReportViewModalOpen: setOpen, saveReportView} = useReportViews();
  const [viewName, setViewName] = useState('');

  const onSubmit = async () => {
    const isAutoSaving = false;
    const state = (await selectedReport.bookmarksManager.capture())?.state;
    const reportId = selectedReport.config.id;

    saveReportView({viewName, isAutoSaving, reportState: state, reportId});
    setOpen(false);
  };

  useEffect(() => {
    setViewName('');
  }, [isOpen]);

  const viewNameAlreadyTaken = reportViews.find(rv => rv.report_state_name === viewName) !== undefined;
  const viewNameIsTooLong = viewName !== '' && !REGULAR_EXPRESSIONS.textWithRangeChars(0, 100).test(viewName);
  const hasError = viewNameIsTooLong || viewNameAlreadyTaken;

  const disabled = !viewName || hasError;

  const getErrorText = () => {
    if (viewNameIsTooLong) {
      return REGULAR_EXPRESSIONS_ERROR_TEXTS.textWithRangeChars(0, 100);
    }
    if (viewNameAlreadyTaken) {
      return 'Ce nom de vue est déjà pris';
    }
    return '';
  };

  return (
    <BaseModal canCloseOnBackdropClick={false} hasCloseIcon onClose={() => setOpen(false)} open={isOpen} title="Sauvegarder une vue">
      <Box p={3}>
        <TextField
          error={hasError}
          helperText={getErrorText()}
          fullWidth
          label="Choisissez le nom de la vue"
          value={viewName}
          onChange={e => setViewName(e.target.value)}
          sx={{mb: 2}}
          onKeyDown={async e => {
            if (e.key === 'Enter' && !e.shiftKey && !disabled) {
              e.preventDefault();
              await onSubmit();
            }
          }}
        />
        <Grid container justifyContent="center">
          <Button size="large" disabled={disabled} variant="contained" color="secondary" onClick={onSubmit}>
            Sauvegarder la vue
          </Button>
        </Grid>
      </Box>
    </BaseModal>
  );
};

export default SaveReportViewModal;
